import { render, staticRenderFns } from "./side-menubar.vue?vue&type=template&id=7c7e9f88&lang=pug&"
import script from "./side-menubar.vue?vue&type=script&lang=js&"
export * from "./side-menubar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports